import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Container, Grid, Image, Responsive} from "semantic-ui-react";

import {APP} from '../../../constants';
import {fetchCategoriesFavorites} from "../../../redux/actions";
import TinySlider from "tiny-slider-react";
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";

const defaultPath = APP.images.categories.path;
const defaultCityPath = APP.images.cities.path;
const defaultImage = APP.images.categories.image;

const settings = {
    lazyload: true,
    nav: true,
    controls: false,
    mouseDrag: true,
    navPosition: "bottom",
    loop: true,
    items: 1,
    gutter: 20,
    responsive: {
        420: {
            items: 1
        },
        960: {
            items: 3
        }
    }
};
const getWidth = () => {
    const isSSR = typeof window === 'undefined';

    return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

const Categories = ({city_id, subdomain}) => {

    const [favorites, setFavorites] = useState([]);

    const cities = useSelector(state => state.Cities.results);

    useEffect(() => {
        async function fetchCategoriesData() {
            const res = await fetchCategoriesFavorites(city_id);
            setFavorites(res.data);
        }

        async function fetchCitiesData() {
            if(cities.success){
                const options = cities.data.filter((o) => {
                    return o.favorite;
                });
                setFavorites(options);
            }
        }

        if (city_id === 7) {
            // noinspection JSIgnoredPromiseFromCall
            fetchCitiesData();
        } else {
            // noinspection JSIgnoredPromiseFromCall
            fetchCategoriesData();
        }

    }, [city_id, cities])

    const renderFavorites = (position) => {
        let max = 8;
        return favorites.slice(0, max).map(
            (row) => {
                const {place_count, name, image, id, slug, icon, future} = row;

                let imageUrl = defaultImage;
                if (image && city_id === 7) {
                    imageUrl = defaultCityPath + image;
                } else {
                    imageUrl = (defaultPath + image).replace('big', 'small');
                }

                return (
                    <Grid.Column key={`category-${id}`} style={{
                        height: 240,
                        backgroundImage: `url(${imageUrl})`,
                        backgroundSize: 'cover',
                        position
                    }}>
                        <Link
                            onClick={
                                () => {
                                    if(future){
                                        return;
                                    }

                                    if (city_id === 7) {
                                        localStorage.setItem('_CITY', JSON.stringify({
                                            key: id,
                                            text: name,
                                            slug: slug,
                                            value: id
                                        }));
                                        window.location.reload();
                                    }
                                }
                            }
                            to={
                                () => {
                                    if(future){
                                        return undefined;
                                    }

                                    return city_id !== 7
                                        ? `/categories/${id}/${slug}?id=${id}`
                                        : `/`;
                                }
                            }
                        >
                            <div className={`content ${icon}`}>
                                {
                                    icon && <Image src={`/images/icons/${icon}.png`} width={72}/>
                                }
                                {place_count && `${place_count} `}{name}
                                {future && <p><FormattedMessage id={"EM BREVE"}/></p>}
                            </div>
                        </Link>
                    </Grid.Column>
                );
            }
        );
    }

    return (
        <Container as="section" fluid className={`section-categories _${subdomain} _${city_id}`} style={{paddingTop: 0}}>
            <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
                <Grid stackable>
                    {renderFavorites()}
                </Grid>
            </Responsive>
            <Responsive getWidth={getWidth} maxWidth={Responsive.onlyMobile.maxWidth}>
                <div style={{
                    position: 'relative',
                    width: "100%",
                }}>
                    <TinySlider settings={settings}>
                        {renderFavorites('relative')}
                    </TinySlider>
                </div>
            </Responsive>
        </Container>
    );
}

export default Categories;
